import React, { useState, useRef, useEffect } from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { FaSearch } from "react-icons/fa"
import Search from "./Search"

const SearchBar2 = () => {
  const childRef = useRef(null)
  const { allStrapiCategory } = useStaticQuery(graphql`
    {
      allStrapiCategory {
        nodes {
          name
          slug
        }
      }
    }
  `)
  const [searchShow, setSearchShow] = useState(false)

  useEffect(() => {
    if (searchShow) {
      childRef.current.focus()
    }
  }, [searchShow])

  return (
    <>
      <div className="nav-tags2" >
        {searchShow ? (
          <Search forwardedRef={childRef} />
        ) : (
          allStrapiCategory.nodes.map((category, index) => {
            return (
              <Link
                key={index}
                to={`/tags/${category.slug}`}
                className="nav-tag"
              >
                <div className="link">
                  <h3> {category.name} </h3>
                </div>
              </Link>
            )
          })
        )}
        <FaSearch
          className="search-icon"
          onClick={() => setSearchShow(!searchShow)}
        />
      </div>
    </>
  )
}

export default SearchBar2
